<div class="d-lg-block d-none">
  <fgb-banner [title]="'earn.text' | translate"></fgb-banner>
</div>

<div class="widget-mobile">
  <div class="container">
    <h5 class="sub-heading font-page-heading mt-4 text-black pb-0">
      {{ 'earn.page.intro.heading' | translate }}
    </h5>
    <div >
      {{ 'earn.page.intro.description' | translate }}
    </div>
  </div>

  <div class="container earn-points-container">
    <fgbcl-earn-points></fgbcl-earn-points>
  </div>
</div>
